/**
 * Default name for when a business unit name is not provided
 */
export const EMPTY_BUSINESS_UNIT_NAME = 'Business Units & Segments';
